import React, { createContext, useMemo, useState } from 'react';
import { useColorScheme } from 'react-native';
import { createTheme } from '../utils';
export const ThemeContext = createContext(null);
export const ThemeContextProvider = ({ children, defaultColorScheme, forcedColorScheme }) => {
    const preferredColorScheme = useColorScheme();
    const [colorScheme, setColorScheme] = useState(preferredColorScheme);
    const theme = useMemo(() => { var _a; return createTheme((_a = forcedColorScheme !== null && forcedColorScheme !== void 0 ? forcedColorScheme : colorScheme) !== null && _a !== void 0 ? _a : defaultColorScheme); }, [defaultColorScheme, colorScheme, forcedColorScheme]);
    return (React.createElement(ThemeContext.Provider, { value: { theme, setColorScheme } }, children));
};
//# sourceMappingURL=ThemeContext.js.map